import { useState, useEffect } from "react";
import { Platform } from "react-native";

export function useIsPreview() {
	const [isPreview, setIsPreview] = useState(false);

	useEffect(() => {
		if (Platform.OS === "web") {
			const urlParams = new URLSearchParams(window.location.search);
			const previewParam = urlParams.get("preview");
			setIsPreview(previewParam === "true" || previewParam === "");
		}
	}, []);


	return isPreview;
}
